import React, {
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react';
import classNames from 'classnames';

import { WithChildren } from 'common/types';

import styles from './styles.module.scss';

export interface ICheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string,
  label?: string,
  description?: string,
  disabled?: boolean,
  error?: string | undefined,
  image?: string,
}

const Checkbox = forwardRef(({
  name,
  label,
  image,
  className,
  description,
  disabled,
  children,
  error,
  ...props
}: WithChildren<ICheckboxProps>, ref: ForwardedRef<HTMLInputElement>) => (
  <div className={classNames(
    styles.wrapper,
    'common-components-Checkbox__wrapper',
  )}
  >
    {image && (
      <img
        className={classNames(styles.image, 'common-components-Checkbox__image')}
        src={image}
        alt={name}
      />
    )}
    <div className={styles.body}>
      <input
        {...props}
        ref={ref}
        type="checkbox"
        id={name}
        className={classNames(styles.input, 'common-components-Checkbox__input')}
        tabIndex={0}
      />
      <label
        htmlFor={name}
        className={classNames(styles.checkbox, 'common-components-Checkbox__checkbox', className, {
          [styles.error]: error,
          [styles.disabled]: disabled,
          'common-components-Checkbox__checkbox--error': error,
          'common-components-Checkbox__checkbox--disabled': disabled,
        })}
      >
        {label || children}
      </label>

      {description && <p className={classNames(styles.description, 'common-components-Checkbox__description')}>{description}</p>}
      {error && <p className={classNames(styles.errorMessage, 'common-components-Checkbox__errorMessage')}>{error}</p>}
    </div>
  </div>
));

// @ts-ignore
export default Checkbox;
